import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import ReCaptcha from 'react-google-recaptcha'
import {Input, Select, Spin} from 'antd'
import UserAgreement from './UserAgreement'

import style from './signup.sass'

@inject('store') @observer
class Form extends Component {
  state = {passwordFocus: false}
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.store.signup.openModal()
  }
  handleOk = () => {
    this.props.store.signup.submit()
  }
  handleCancel = () => {
    this.props.store.signup.closeModal()
  }
  handleChange = (e) => {
    const {name, value} = e.target
    this.props.store.signup.setCredentials(name, value)
  }
  handleSelect = (value) => {
    this.props.store.signup.setCredentials('is_professional_trader', value)
  }
  handleMultiselect = (value) => {
    this.props.store.signup.setCredentials('instruments2', value)
  }
  handleBlur = (e) => {
    this.props.store.signup.validateField(e.target.name)
  }
  handleFocus = (e) => {
    this.props.store.signup.removeError(e.target.name)
  }
  passwordFocus = (e) => {
    this.setState({passwordFocus: true})
    this.handleFocus(e)
  }
  passwordBlur = (e) => {
    this.setState({passwordFocus: false})
    this.handleBlur(e)
  }
  handleRecaptcha = (value) => {
    this.props.store.signup.setCredentials('recaptcha_response', value)
  }
  render() {
    const {passwordFocus} = this.state
    const {credentials, errors, loading, modal} = this.props.store.signup
    return(
      <form styleName='form' onSubmit={this.handleSubmit}>
        <div styleName='field'>
          <label htmlFor='first-name'>First Name <span>*</span></label>
          <Input
            size='large'
            type='text'
            name='first_name'
            value={credentials.first_name}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            onFocus={this.handleFocus}
            styleName={errors.first_name ? 'has-error' : ''}
          />
          <p styleName='error'>{errors.first_name}</p>
        </div>
        <div styleName='field'>
          <label htmlFor='last-name'>Last Name <span>*</span></label>
          <Input
            size='large'
            type='text'
            name='last_name'
            value={credentials.last_name}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            onFocus={this.handleFocus}
            styleName={errors.last_name ? 'has-error' : ''}
          />
          <p styleName='error'>{errors.last_name}</p>
        </div>
        <div styleName='field'>
          <label htmlFor='email'>Email <span>*</span></label>
          <Input
            size='large'
            type='email'
            name='email'
            value={credentials.email}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            onFocus={this.handleFocus}
            styleName={errors.email ? 'has-error' : ''}
          />
          <p styleName='error'>{errors.email}</p>
        </div>
        <div styleName='select'>
          <label htmlFor='trader'>Are you a professional trader?</label>
          <Select
            name='is_professional_trader'
            style={{width:'100%'}}
            size='large'
            value={credentials.is_professional_trader}
            onChange={this.handleSelect}
          >
            <Select.Option value='true'>Yes</Select.Option>
            <Select.Option value='false'>No</Select.Option>
          </Select>
        </div>
        <div styleName='field'>
          <label htmlFor='assets'>Which asset classes/instruments do you trade?</label>
          <Select
            name='instruments2'
            style={{width:'100%'}}
            size='large'
            mode='multiple'
            value={credentials.instruments2}
            onChange={this.handleMultiselect}
          >
            <Select.Option value='equities'>equities</Select.Option>
            <Select.Option value='currencies'>currencies</Select.Option>
            <Select.Option value='commodities'>commodities</Select.Option>
            <Select.Option value='bonds'>bonds</Select.Option>
            <Select.Option value='derivatives'>derivatives</Select.Option>
            <Select.Option value='other'>other</Select.Option>
          </Select>
        </div>
        <div styleName='field'>
          <label htmlFor='password'>Password <span>*</span></label>
          <Input
            size='large'
            type='password'
            name='password'
            value={credentials.password}
            onChange={this.handleChange}
            onBlur={this.passwordBlur}
            onFocus={this.passwordFocus}
            styleName={errors.password ? 'has-error' : ''}
          />
          {passwordFocus
            ? <p styleName='error' style={{color: 'inherit'}}>Password must be at least 10 characters, and contain at least 1 digit, 1 letter and 1 special character</p>
            : <p styleName='error'>{errors.password}</p>
          }
        </div>
        <div styleName='field'>
          <label htmlFor='password2'>Confirm password <span>*</span></label>
          <Input
            size='large'
            type='password'
            name='password_repeat'
            value={credentials.password_repeat}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            onFocus={this.handleFocus}
            styleName={errors.password_repeat ? 'has-error' : ''}
          />
          <p styleName='error'>{errors.password_repeat}</p>
        </div>
        <div styleName='field'>
          <ReCaptcha
            sitekey='6LcQVmUUAAAAAEJaWtdSFswV-iFmsV6j61gHiqTm'
            onChange={this.handleRecaptcha}
          />
        </div>
        <div styleName='button'>
          <button type='submit' styleName={loading ? 'loading' : ''} disabled={true}>
            {loading ? <Spin size='small' styleName='spin'/> : 'Sign Up'}
          </button>
        </div>
        <UserAgreement
          visible={modal}
          handleOk={this.handleOk}
          handleCancel={this.handleCancel}
          loading={loading}
        />
      </form>
    )
  }
}

export default Form
